import { RULES } from '../graphql/queries/rule';
import { useFetchItems } from './useFetchItems';
/**
 * Custom hook for fetching rules based on the provided clientId and ruleType.
 *
 * @param {UseRulesProps} props - The properties for the useRules hook.
 * @param {number} props.clientId - The client ID.
 * @param {string} props.ruleType - The rule type.
 * @param {RuleSpec} props.ruleSpec - Optional specification for additional rule filtering criteria.
 * @returns {Object} - An object containing the fetched items, error, and loading state.
 */
export const useRules = ({ clientId, ruleType, ruleSpec }) => {
    const { items, error, loading, refetch } = useFetchItems({
        fetchQuery: RULES,
        dataProp: 'rules',
        skip: !clientId,
        spec: { ...(ruleSpec ?? {}), clientId, ruleType },
    });
    return {
        items,
        error,
        loading,
        refetch,
    };
};
